// @flow
import * as React from 'react';
import { Button, Fade, Stack, Typography } from '@mui/material';
import { Client } from '../../../../shared/api/use-client-subscription';
import { AddNoteButton, AddManagerNoteButton, NoteItem } from '../notes';
import _ from 'lodash';
import { useNavigate } from 'react-router-dom';
import { getRoute } from '../../../../app/router';

type Props = {
  notes?: Client['notes'];
};
export const NotesOverview = ({notes = []}: Props) => {
  const lastNotes = _.take(_.orderBy(notes, 'updatedAt', 'desc'), 4);
  const navigate = useNavigate();

  return (
    <Stack gap={1} flex={1}>
      <Stack gap={2} direction={'row'} alignItems={'center'}>
        <Typography variant={'subtitle1'} flex={1}>Notes</Typography>
        <Fade in={!!lastNotes.length}>
          <Button size={'small'} variant={'outlined'}
                  onClick={() => navigate(`/${getRoute('client')}/${lastNotes[0].clientId}/notes`)}
                  sx={{alignSelf: 'flex-end'}}>View all</Button>
        </Fade>
        <AddManagerNoteButton />
        <AddNoteButton />
      </Stack>
      {!lastNotes.length && <Stack alignItems={'center'} height={50} justifyContent={'center'}>
        <Typography variant={'body2'} color={'#a5a5a5'}>No notes yet</Typography>
      </Stack>}
      {!!lastNotes.length && (
        <Stack gap={1}>
          {lastNotes.map((note, i) => (
            <NoteItem note={note} key={note.id} />
          ))}
        </Stack>
      )}
    </Stack>
  );
};
